'use client';

import Link from 'next/link';
import * as styles from './OrganizerBanner.css';

interface OrganizerButtonsProps {
  defaultLinkHref: string;
  outlineLinkHref: string;
}

export function OrganizerButtons({ defaultLinkHref, outlineLinkHref }: OrganizerButtonsProps) {
  const trackButtonClick = (buttonName: string) => {
    if (window?.dataLayer) {
      window.dataLayer.push({
        event: 'stck',
        stckEventCategory: 'home_click_banner',
        stckEventLabel: buttonName,
      });
    }
  };

  return (
    <div className={styles.buttonsContainer}>
      <Link
        className={styles.link.default}
        href={defaultLinkHref}
        onClick={() => trackButtonClick('crie-seu-evento')}
      >
        Crie seu evento
      </Link>
      <Link
        className={styles.link.outline}
        target="_blank"
        href={outlineLinkHref}
        onClick={() => trackButtonClick('veja-como-funciona')}
      >
        Veja como funciona
      </Link>
    </div>
  );
}
